import { createContext, useState } from "react"
import { Segment } from "semantic-ui-react"
import { ObjectActionGroup } from "../Types"


interface TaskIdContextType {
    taskId?: number | null;
    setTaskId: (newTaskId: number) => void;
}

export const TaskIdContext = createContext<TaskIdContextType>({ setTaskId: () => { } });

export const ObjectStateComponent = ((props: { objectState: React.ReactNode, task: ObjectActionGroup }) => {
    const task = props.task
    const [taskId, setTaskId] = useState(props.task.id)
    const objectState = props.objectState

    return <Segment data-testid={task.id.toString()}>
        <div>
            <div>
                <div>{task.object.taskType.name}</div>
                <b>{task.object.name}</b>
                <div>({task.object.priority})</div>
                <b>[{task.object.quantity}]</b>
                <b>{task.object.endAddress.name}</b>
            </div>
            <div>[Soute: {task.object.position ? task.object.position : "-"}]</div>
        </div>
        <div>
            <div>
                <TaskIdContext.Provider value={{ taskId, setTaskId }}>
                    {objectState && typeof objectState === 'object' && 'props' in objectState && objectState.props.buttons && objectState.props.buttons.filter((button: any) =>
                        (button.props.showForTaskType.length === 0 || button.props.showForTaskType.includes(task.object.taskType.id)) &&
                        (button.props.showForTaskLoadMode.includes("NONE") || button.props.showForTaskLoadMode.length === 0)
                    )}
                </TaskIdContext.Provider>
            </div>
        </div>
    </Segment>
})